import React from "react";
import { Box, Typography } from "@mui/material";
import CustomTextField from "../../../../../components/ui/Textfield";

interface RoleBasicsStepProps {
  name: string;
  onNameChange: (name: string) => void;
}

const RoleBasicsStep: React.FC<RoleBasicsStepProps> = ({ name, onNameChange }) => (
  <Box maxWidth={480}>
    <Typography variant="h6" fontWeight="bold" mb={0.5}>
      Name this role
    </Typography>
    <Typography variant="body2" color="text.secondary" mb={3}>
      Choose a clear, descriptive name — you&apos;ll pick its permissions next.
    </Typography>

    <CustomTextField
      label="Role Name"
      placeholder="e.g. Event Crew"
      value={name}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onNameChange(e.target.value)}
      fullWidth
      autoFocus
    />
  </Box>
);

export default RoleBasicsStep;
